"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = __importDefault(require("./Button"));
var OutlineButton = styled_components_1["default"](Button_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:after {\n    content: ' ';\n    box-shadow: inset 0 0 0 2px ", ";\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: ", ";\n  }\n"], ["\n  color: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:after {\n    content: ' ';\n    box-shadow: inset 0 0 0 2px ", ";\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (props) { return (props.disabled ? null : props.theme.colors.primary); }, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightGray;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius;
});
OutlineButton.displayName = 'OutlineButton';
exports["default"] = OutlineButton;
var templateObject_1;
//# sourceMappingURL=OutlineButton.js.map